import { Trans } from "react-i18next";function countSelectedInService(service, selected) {
  return service.modules
  .flatMap((m) => m.sub_modules.flatMap((sm) => sm.permissions.map((p) => p.id)))
  .filter((id) => selected.has(id)).length;
}

export default function SelectionSummary({ permissionMaster, selected }) {
  const selectedServicesCount = permissionMaster.filter((s) =>
  s.modules.some((m) => m.sub_modules.some((sm) => sm.permissions.some((p) => selected.has(p.id))))
  ).length;
  const selectedModulesCount = permissionMaster.flatMap((s) => s.modules).filter(
    (m) => m.sub_modules.some((sm) => sm.permissions.some((p) => selected.has(p.id)))
  ).length;
  const selectedSubmodulesCount = permissionMaster
  .flatMap((s) => s.modules.flatMap((m) => m.sub_modules))
  .filter((sm) => sm.permissions.some((p) => selected.has(p.id))).length;
  const selectedPermsCount = selected.size;

  const serviceBreakdown = permissionMaster
  .map((s) => ({ name: s.name, count: countSelectedInService(s, selected) }))
  .filter((x) => x.count > 0);

  return (
    <div className="cer-summary">
      <h3 className="cer-summary__title"><Trans i18nKey="roles.selectionSummary" /></h3>
      <div className="cer-summary__counts">
        <div className="cer-summary__count-item">
          <div className="cer-summary__count-icon cer-summary__count-icon--blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <div><span className="cer-summary__count-num">{selectedServicesCount}</span><span className="cer-summary__count-label"><Trans i18nKey="common.services" /></span></div>
        </div>
        <div className="cer-summary__count-item">
          <div className="cer-summary__count-icon cer-summary__count-icon--green">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
            </svg>
          </div>
          <div><span className="cer-summary__count-num">{selectedModulesCount}</span><span className="cer-summary__count-label"><Trans i18nKey="roles.modules" /></span></div>
        </div>
        <div className="cer-summary__count-item">
          <div className="cer-summary__count-icon cer-summary__count-icon--orange">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 6h18M3 12h12M3 18h8" /></svg>
          </div>
          <div><span className="cer-summary__count-num">{selectedSubmodulesCount}</span><span className="cer-summary__count-label"><Trans i18nKey="roles.submodules" /></span></div>
        </div>
        <div className="cer-summary__count-item">
          <div className="cer-summary__count-icon cer-summary__count-icon--purple">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <polyline points="9 11 12 14 22 4" />
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
          </div>
          <div><span className="cer-summary__count-num">{selectedPermsCount}</span><span className="cer-summary__count-label"><Trans i18nKey="roles.permissionsSelected" /></span></div>
        </div>
      </div>

      {serviceBreakdown.length > 0 &&
      <div className="cer-summary__breakdown">
          <p className="cer-summary__breakdown-title"><Trans i18nKey="roles.selectedItems" /></p>
          <ul className="cer-summary__breakdown-list">
            {serviceBreakdown.map((item) =>
          <li key={item.name} className="cer-summary__breakdown-item">
                <span className="cer-summary__breakdown-name">{item.name}</span>
                <span className="cer-summary__breakdown-count">{item.count}</span>
              </li>
          )}
          </ul>
        </div>
      }

      <div className="cer-summary__tip">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <div>
          <p className="cer-summary__tip-head"><Trans i18nKey="roles.howItWorks" /></p>
          <p className="cer-summary__tip-body"><Trans i18nKey="roles.selectingAServiceModuleOrSubmoduleWillAutomatically" /></p>
        </div>
      </div>
    </div>);

}
